export function transformFormatSource(
  items: { id: string | number; name: string }[],
) {
  const arr = items.map(({ id, name }) => ({
    value: id.toString(),
    text: name,
  }));

  arr.sort((a, b) => (a.text < b.text ? -1 : 1));

  return arr;
}



// WEBPACK FOOTER //
// ./src/tools/transformSource.ts